import css from './HighlightedTitle.module.scss';
import { Highlight } from '../Highlight';
import { Text } from '@epam/promo';
import React from 'react';
import { HighlightedTitleProps } from './HighlightedTitle.model';

export const HighlightedTitle = ({ title }: HighlightedTitleProps) => {
  return (
    <Text
      color="gray90"
      cx={css['highlighted-title']}
      fontSize="16"
      fontWeight="600"
      lineHeight="24"
      rawProps={{
        'data-testid': 'highlighted-title',
      }}
      size="24">
      <Highlight text={title || 'Title'} />
    </Text>
  );
};
